import { RRule } from 'rrule';
import { LocalDateTime, ZoneId, ZonedDateTime, Instant, LocalDate } from '@js-joda/core';
import '@js-joda/timezone';

/**
 * Generates recurrence schedule as a list of LocalDateTime objects.
 *
 * @param {Object} config
 * @param {"DAILY" | "WEEKLY" | "MONTHLY"} config.frequency
 * @param {number} config.interval - Interval of recurrence (e.g. every 2 weeks)
 * @param {string} config.startDate - ISO string (e.g. "2025-04-18T18:00")
 * @param {string} config.endDate - ISO string (e.g. "2025-06-01T00:00")
 * @param {number} [config.dateOfMonth] - For monthly: day of month to recur on
 * @param {string[]} [config.weekDays] - For weekly: list of days like ["MO", "WE"]
 */
export function generateRecurrenceSchedule(config) {
  const {
    frequency,
    interval = 1,
    startDate,
    endDate,
    dateOfMonth,
    weekDays = [],
  } = config;

  const zone = ZoneId.of("America/New_York");

  const startLDT = LocalDateTime.parse(startDate);
  const zdtStart = startLDT.atZone(zone);

  const ld = LocalDate.parse(endDate);
  const lt = startLDT.toLocalTime();

  const endLDT = ld.atTime(lt);
  const zdtEnd = endLDT
    .atZone(zone);

  const dtStart = new Date(zdtStart.toInstant().toEpochMilli());
  const until = new Date(zdtEnd  .toInstant().toEpochMilli());


  const options = {
    freq: RRule[frequency],
    interval,
    dtstart: dtStart,
    until,
    tzid: "America/New_York"
  };

  if (frequency === "WEEKLY" && weekDays.length > 0) {
    options.byweekday = weekDays.map(day => RRule[day]);
  }

  if (frequency === "MONTHLY") {
    options.bymonthday = [dateOfMonth || dtStart.getDate()];
  }

  const rule = new RRule(options);

  const allOccurrences = rule.all().map(jsDate => {
    const instant = Instant.ofEpochMilli(jsDate.getTime());
    // const zdt = ZonedDateTime.ofInstant(instant, zone);
    // const ldt = zdt.toLocalDateTime();
  
    return jsDate;
  });

  console.log(allOccurrences);
  

  return {
    recurrenceType: frequency,
    interval,
    total: allOccurrences.length,
    occurrences: allOccurrences,
  };
}
